/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkStoresAmenitiesDetailsResponse } from '../../models/bulk-stores-amenities-details-response';

export interface BulkStoreAmenitiesGetDetails$Params {
  'Active-Tenant-Identifier': string;
  bulkRequestId: string;
}

export function bulkStoreAmenitiesGetDetails(http: HttpClient, rootUrl: string, params: BulkStoreAmenitiesGetDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkStoresAmenitiesDetailsResponse>> {
  const rb = new RequestBuilder(rootUrl, bulkStoreAmenitiesGetDetails.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('bulkRequestId', params.bulkRequestId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BulkStoresAmenitiesDetailsResponse>;
    })
  );
}

bulkStoreAmenitiesGetDetails.PATH = '/summary-bulk-store-amenities/{bulkRequestId}/details';
